export default "__VITE_ASSET__DtGAWyEs__"